// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ion-content {
  --ion-background-color: '';
}
.hide-scroll::-webkit-scrollbar {
  width: 0px;
}

.hide-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.hide-scroll::-webkit-scrollbar-thumb {
  background: transparent;
}

.force-update {
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  z-index: 10000;
  position: fixed;
  height: 100%;
  width: 100%;
  overflow: auto;
  text-align: center;
  padding-top: calc(50vh - 200px);

  .force-update-text {
    text-align: center;
    font-size: x-large;
    font-weight: bold;
  }

  .force-update-content {
    background-color: #fefefe;
    margin: auto;
    padding: 10px;
    border: 1px solid #888;
    width: 300px;
    height: auto;
    border-radius: 20px;
    opacity: 1 !important;

    .force-update-text {
      height: auto;
      padding: 20px 10px;
      border-bottom: 1px solid lightgrey;

      .force-update-icon {
        font-size: 80px;
        color: #dea000;
      }

      .force-update-header-text {
        font-size: 30px;
        font-weight: bold;
        line-height: 0;
      }
      .force-update-body-text {
        font-size: 16px;
        font-weight: normal;
        line-height: 0;
      }
    }
    .force-update-footer {
      padding: 15px 10px 10px 10px;
      font-size: medium;
      font-weight: bold;
      color: #44a735;
    }
  }
}

body {
  &:has(#mobile-sticky-footer) {
    #hubspot-messages-iframe-container {
      position: fixed !important; /* Ensures it stays in place */
      max-height: calc(100% - 90px) !important; /* Adjust height */
      bottom: 90px !important; /* Adjust vertical position */
    }
  }

  &:not(:has(#mobile-sticky-footer)) {
    #hubspot-messages-iframe-container {
      position: fixed; /* Ensures it stays in place */
      max-height: 100%; /* Adjust height */
      bottom: 0%; /* Adjust vertical position */
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B,EAAE,mBAAmB;EACnD,oCAAoC,EAAE,qBAAqB;EAC3D,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,+BAA+B;;EAE/B;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;;IAErB;MACE,YAAY;MACZ,kBAAkB;MAClB,kCAAkC;;MAElC;QACE,eAAe;QACf,cAAc;MAChB;;MAEA;QACE,eAAe;QACf,iBAAiB;QACjB,cAAc;MAChB;MACA;QACE,eAAe;QACf,mBAAmB;QACnB,cAAc;MAChB;IACF;IACA;MACE,4BAA4B;MAC5B,iBAAiB;MACjB,iBAAiB;MACjB,cAAc;IAChB;EACF;AACF;;AAEA;EACE;IACE;MACE,0BAA0B,EAAE,8BAA8B;MAC1D,wCAAwC,EAAE,kBAAkB;MAC5D,uBAAuB,EAAE,6BAA6B;IACxD;EACF;;EAEA;IACE;MACE,eAAe,EAAE,8BAA8B;MAC/C,gBAAgB,EAAE,kBAAkB;MACpC,UAAU,EAAE,6BAA6B;IAC3C;EACF;AACF","sourcesContent":[".ion-content {\n  --ion-background-color: '';\n}\n.hide-scroll::-webkit-scrollbar {\n  width: 0px;\n}\n\n.hide-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.hide-scroll::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\n.force-update {\n  background-color: rgb(0, 0, 0); /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */\n  z-index: 10000;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n  text-align: center;\n  padding-top: calc(50vh - 200px);\n\n  .force-update-text {\n    text-align: center;\n    font-size: x-large;\n    font-weight: bold;\n  }\n\n  .force-update-content {\n    background-color: #fefefe;\n    margin: auto;\n    padding: 10px;\n    border: 1px solid #888;\n    width: 300px;\n    height: auto;\n    border-radius: 20px;\n    opacity: 1 !important;\n\n    .force-update-text {\n      height: auto;\n      padding: 20px 10px;\n      border-bottom: 1px solid lightgrey;\n\n      .force-update-icon {\n        font-size: 80px;\n        color: #dea000;\n      }\n\n      .force-update-header-text {\n        font-size: 30px;\n        font-weight: bold;\n        line-height: 0;\n      }\n      .force-update-body-text {\n        font-size: 16px;\n        font-weight: normal;\n        line-height: 0;\n      }\n    }\n    .force-update-footer {\n      padding: 15px 10px 10px 10px;\n      font-size: medium;\n      font-weight: bold;\n      color: #44a735;\n    }\n  }\n}\n\nbody {\n  &:has(#mobile-sticky-footer) {\n    #hubspot-messages-iframe-container {\n      position: fixed !important; /* Ensures it stays in place */\n      max-height: calc(100% - 90px) !important; /* Adjust height */\n      bottom: 90px !important; /* Adjust vertical position */\n    }\n  }\n\n  &:not(:has(#mobile-sticky-footer)) {\n    #hubspot-messages-iframe-container {\n      position: fixed; /* Ensures it stays in place */\n      max-height: 100%; /* Adjust height */\n      bottom: 0%; /* Adjust vertical position */\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
